import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { UserTenant } from '@arc/arc-shared-frontend';
import {
  DisputeReason,
  ModifiedSessionDocumentInfo,
  SessionDocumentInfo,
  ModifiedDocumentMeta,
  PaymentRulesResponseV1,
  AppliedDiscountMeta,
  PaymentPreviewPayableV1Response,
} from '../../models';

@Component({
  selector: 'payment-selected-documents',
  templateUrl: './selected-documents.component.html',
  styleUrls: ['./selected-documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedDocumentsComponent {
  @Input() subTotal: number;
  @Input() isReadOnly: number;
  @Input() modifiedDocuments: ModifiedSessionDocumentInfo[];
  @Input() paymentRules: PaymentRulesResponseV1;
  @Input() statementPaymentAllowed: boolean;
  @Input() disputeReasons: DisputeReason[];
  @Input() paymentDate: Date;
  @Input() tenantDetails: UserTenant;
  @Input() discountMetadata: AppliedDiscountMeta[];
  @Input() previewPayables: PaymentPreviewPayableV1Response[];

  @Output() creditMemoPayableAmountModified =
    new EventEmitter<SessionDocumentInfo>();

  @Output() invoicePayableAmountModified =
    new EventEmitter<SessionDocumentInfo>();

  @Output() documentAmountModified = new EventEmitter<ModifiedDocumentMeta>();

  @Output() updateAppliedDiscountAmount =
    new EventEmitter<SessionDocumentInfo>();

  @Output() selectedDocumentsChanged = new EventEmitter<
    ModifiedSessionDocumentInfo[]
  >();

  constructor() {}

  onEditPayableAmount(document: SessionDocumentInfo): void {
    if (document.isCreditMemo) {
      this.creditMemoPayableAmountModified.emit(document);
      return;
    }

    this.invoicePayableAmountModified.emit(document);
  }

  onMarkDocumentAsModified(docUrn: ModifiedDocumentMeta): void {
    this.documentAmountModified.emit(docUrn);
  }

  onUpdateAppliedDiscountAmount(): void {
    this.updateAppliedDiscountAmount.emit();
  }

  onSelectedDocumentsChanged(
    modifiedDocuments: ModifiedSessionDocumentInfo[],
  ): void {
    this.selectedDocumentsChanged.emit(modifiedDocuments);
  }
}
